{
  "remove": "Remover"
}
